import Vue from 'vue'

export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_SIGNOUT = 'USER_SIGNOUT';

export default {
    state: {
        token: localStorage.getItem('token') || ''
    },
    mutations: {
        [USER_SIGNIN](state, token){
            console.log(token, 'yyyyyyyy')
            localStorage.setItem('token', token);
            Object.assign(state, { token });
        },
        [USER_SIGNOUT](state){
            localStorage.removeItem('token');
            Object.keys(state).forEach(k => Vue.delete(state, k));
        }
    },
    actions: {
        [USER_SIGNIN]({commit}, token){
            commit(USER_SIGNIN, token);
        },
        [USER_SIGNOUT]({commit}, token){
            commit(USER_SIGNOUT, token);
        }
    }
}